import { createGenericListItemReducer } from "common/genericListItemReducer";
import { combineReducers } from "redux";
import {
  PDF_EXISTS_REQUESTED,
  PDF_EXISTS_REQUEST_FAILED,
  PDF_EXISTS_REQUEST_RECEIVED,
  UNZIP_PDF_REQUESTED,
  UNZIP_PDF_REQUEST_FAILED,
  UNZIP_PDF_REQUEST_RECEIVED
} from "./unzipPdfActions";

export const pdf = combineReducers({
  pdf: createGenericListItemReducer(UNZIP_PDF_REQUESTED, UNZIP_PDF_REQUEST_RECEIVED, UNZIP_PDF_REQUEST_FAILED),
  exists: createGenericListItemReducer(PDF_EXISTS_REQUESTED, PDF_EXISTS_REQUEST_RECEIVED, PDF_EXISTS_REQUEST_FAILED)
});
